// Module Configuration - Define all modules and their role-based access
export const modulesConfig = {
    // Admin modules
    staffProfile: {
        id: 'staff-profile',
        name: 'My Profile',
        description: 'View and update your staff profile, branch and role details',
        icon: '👤',
        path: '/staff-profile',
        permission: 'staff_profile.read',
        roles: ['admin', 'treasurer', 'secretary', 'chair', 'union_official', 'branch_leader', 'committee', 'auditor'],
        color: '#ca8a04'
    },
    dashboard: {
        id: 'dashboard',
        name: 'Dashboard',
        description: 'System overview and statistics',
        icon: '📊',
        path: '/dashboard',
        permission: 'dashboard.view',
        roles: ['admin', 'treasurer', 'secretary', 'chair'],
        color: '#3b82f6'
    },
    members: {
        id: 'members',
        name: 'Members',
        description: 'Manage system members',
        icon: '👥',
        path: '/members',
        permission: 'members.read',
        roles: ['admin', 'treasurer', 'secretary'],
        color: '#10b981'
    },
    branches: {
        id: 'branches',
        name: 'Matawi (Branches)',
        description: 'Manage branches',
        icon: '🌿',
        path: '/branches',
        permission: 'branches.read',
        roles: ['admin', 'secretary'],
        color: '#8b5cf6'
    },
    contributions: {
        id: 'contributions',
        name: 'Contributions',
        description: 'Track member contributions',
        icon: '💰',
        path: '/contributions',
        permission: 'contributions.read',
        roles: ['admin', 'treasurer', 'member'],
        color: '#f59e0b'
    },
    accounting: {
        id: 'accounting',
        name: 'Accounting',
        description: 'Financial years, accounts and journals',
        icon: '📒',
        path: '/accounting/overview',
        permission: 'finance.read',
        roles: ['admin', 'treasurer', 'auditor'],
        color: '#0f766e'
    },
    requisitions: {
        id: 'requisitions',
        name: 'Staff Requisitions',
        description: 'Request goods and services against an approved budget',
        icon: '🧾',
        path: '/staff-requisitions',
        permission: 'requisitions.read',
        roles: ['admin', 'treasurer', 'secretary', 'chair', 'union_official', 'branch_leader', 'committee', 'auditor'],
        color: '#0d9488'
    },
    loans: {
        id: 'loans',
        name: 'Loans',
        description: 'Manage loans and disbursements',
        icon: '🏦',
        path: '/loans',
        permission: 'loans.read',
        roles: ['admin', 'treasurer', 'member'],
        color: '#06b6d4'
    },
    communications: {
        id: 'communications',
        name: 'Messages',
        description: 'Send announcements and messages',
        icon: '📱',
        path: '/communications',
        permission: 'communications.read',
        roles: ['admin', 'secretary', 'chair'],
        color: '#ec4899'
    },
    engagement: { id:'engagement', name:'Member Engagement', description:'Surveys, feedback and member responses', icon:'💬', path:'/engagement', permission:'engagement.read', roles:['admin','secretary','chair','union_official','branch_leader','member'], color:'#b79200' },
    meetings: {
        id: 'meetings',
        name: 'Meetings',
        description: 'Schedule and manage meetings',
        icon: '🗓️',
        path: '/meetings',
        permission: 'meetings.read',
        roles: ['admin', 'secretary', 'chair', 'member'],
        color: '#14b8a6'
    },
    elections: {
        id: 'elections',
        name: 'Elections',
        description: 'Manage elections and voting',
        icon: '🗳️',
        path: '/elections',
        permission: 'elections.read',
        roles: ['admin', 'chair', 'member'],
        color: '#f97316'
    },
    idCards: {
        id: 'id-cards',
        name: 'ID Cards',
        description: 'Generate member ID cards',
        icon: '🪪',
        path: '/id-cards',
        permission: 'id_cards.read',
        roles: ['admin', 'treasurer'],
        color: '#06b6d4'
    },
    cardTemplates: {
        id: 'card-templates',
        name: 'Card Templates',
        description: 'Design ID card templates',
        icon: '🎨',
        path: '/card-templates',
        permission: 'id_cards.manage',
        roles: ['admin'],
        color: '#a855f7'
    },
    recruitment: {
        id: 'recruitment',
        name: 'Ajira (Jobs)',
        description: 'Job postings and recruitment',
        icon: '💼',
        path: '/recruitment',
        permission: 'recruitment.read',
        roles: ['admin', 'secretary', 'union_official'],
        color: '#6366f1'
    },
    reports: {
        id: 'reports',
        name: 'Reports',
        description: 'Financial and system reports',
        icon: '📈',
        path: '/reports',
        permission: 'reports.read',
        roles: ['admin', 'treasurer', 'chair'],
        color: '#e11d48'
    },
    users: {
        id: 'users',
        name: 'Users',
        description: 'Manage system users',
        icon: '👤',
        path: '/users',
        permission: 'admin.users',
        roles: ['admin'],
        color: '#64748b'
    },
    settings: {
        id: 'settings',
        name: 'System Settings',
        description: 'Configure email, SMS and system integrations',
        icon: '⚙️',
        path: '/settings',
        permission: 'admin.users',
        roles: ['admin'],
        color: '#eab308'
    },
    
    // Member-specific modules
    myProfile: {
        id: 'my-profile',
        name: 'My Profile',
        description: 'View and edit your profile',
        icon: '👤',
        path: '/profile',
        roles: ['member'],
        color: '#3b82f6'
    },
    myId: {
        id: 'my-id',
        name: 'My ID',
        description: 'Download your ID card',
        icon: '🆔',
        path: '/my-id',
        roles: ['member'],
        color: '#06b6d4'
    },
    trainings: {
        id: 'trainings',
        name: 'Trainings',
        description: 'View available trainings',
        icon: '🎓',
        path: '/trainings',
        permission: 'trainings.read',
        roles: ['admin', 'secretary', 'chair', 'union_official', 'member'],
        color: '#8b5cf6'
    },
    cases: {
        id: 'cases',
        name: 'Cases',
        description: 'View legal cases',
        icon: '⚖️',
        path: '/cases',
        roles: ['member'],
        color: '#f59e0b'
    },
    library: {
        id: 'library',
        name: 'Library',
        description: 'Access library resources',
        icon: '📚',
        path: '/library',
        roles: ['member'],
        color: '#10b981'
    },
    support: {
        id: 'support',
        name: 'Support',
        description: 'Get help and support',
        icon: '🛠️',
        path: '/support',
        permission: 'support.read',
        roles: ['admin', 'secretary', 'chair', 'union_official', 'branch_leader', 'member'],
        color: '#ec4899'
    },
    calendar: {
        id: 'calendar',
        name: 'Calendar',
        description: 'View events calendar',
        icon: '📆',
        path: '/calendar',
        roles: ['member'],
        color: '#f97316'
    },
};

// Get modules accessible by a specific role
export const getModulesByRole = (role) => {
    return Object.values(modulesConfig).filter(module => 
        module.roles.includes(role)
    );
};

export const getModulesForUser = (user) => {
    if (!user) return [];
    const permissions = Array.isArray(user.permissions) ? user.permissions : [];
    const userRoles = Array.isArray(user.roles) && user.roles.length ? user.roles : [user.role];
    return Object.values(modulesConfig).filter(module => {
        if (!module.roles.some(role => userRoles.includes(role))) return false;
        if (!module.permission) return true;
        return permissions.includes('*') || permissions.includes(module.permission)
            || permissions.includes(`${module.permission.split('.')[0]}.*`);
    });
};

// Check if user has access to a module
export const hasAccessToModule = (role, moduleId) => {
    const module = modulesConfig[moduleId];
    return module && module.roles.includes(role);
};

// Get all unique roles
export const getAllRoles = () => {
    const roles = new Set();
    Object.values(modulesConfig).forEach(module => {
        module.roles.forEach(role => roles.add(role));
    });
    return Array.from(roles);
};
